export default __webpack_public_path__ + "static/media/gh.06e31fa9.svg";